<ng-container *ngIf="!isOnline && isBrowser">
  <div class="error-network-message">
    {{ 'no_internet' | translate }}
  </div>
</ng-container>
<div
  *ngIf="!(versionHandlerService.isReloadVersion || reloadLocationPending) && loadingSetting"
  class="body-block"
  [ngStyle]="{ height: height }"
>
  <router-outlet></router-outlet>
</div>
<div class="loader-animation" *ngIf="versionHandlerService.isReloadVersion || reloadLocationPending">
  <img src="./assets/img/loader-animation.gif" alt="loader">
</div>
